<template>
  <session class="page-plan js-page-plan">
    <div ref="pageFirstBlockRef" />
    <div class="blocktitle">
      <div class="backwrap" @click="goBack"><Icon name="back" /><span>{{LOCAL('back')}}</span></div>
    </div>
    <div class="plan-block1">
      <div class="plan-block plan-block1-l">
        <div class="line" />
        <Icon :name="({ person: 'gerenbaozhang', unit: 'jigoubaozhang' })[mode]" size="40" />
        <div class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{block1Title}}</div>
        <div class="desc">{{block1Desc}}</div>
        <div class="btns">
          <div class="item primary" @click="Utils.loginDialogToggle(true,'person')"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block1Btn1 }}</span></div>
          <div class="item" @click="downloadFile"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{block1Btn2}}</span></div>
        </div>
      </div>
      <div class="plan-block1-r" :style="{ backgroundImage: `url(${block1Cover})` }"></div>
    </div>
    
    <div class="plan-block plan-block2" ref="block2Ref">
      <div class="block-header">
        <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block2Title }}</span>
        <span />
      </div>
      <div class="block-body">
        <div class="category">
          <div class="item" v-for="(item, index) in block2Category" :key="index">
            <div class="order">{{ item?.order }}</div>
            <div class="name" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.name }}</div>
            <div class="iconwrap"><Icon :name="item?.icon" size="56" /></div>
          </div>
        </div>
        <div class="list">
          <div class="item" v-for="(item, index) in block2List" :key="index">
            <div class="title">
              <Icon :name="item?.icon" />
              <span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.title }}</span>
            </div>
            <div class="desc">{{ item?.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="plan-block plan-block3">
      <div class="block-header">
        <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block3Title }}</span>
        <span />
      </div>
      <div class="block-body">
        <div class="list">
          <div class="item" v-for="(item, index) in block3List" :key="index">
            
            <div class="title"><Icon :name="item?.icon" size="32" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.title }}</span></div>
            <div class="desc">{{ item?.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="moreinfo-block">
      <div class="moreinfo-h">
        <div class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ moreinfoTitle }}</div>
        <div class="desc">{{ moreinfoDesc }}</div>
        <div class="contactbtn" @click="Utils.toTargetPage('/contactus')">
          <Icon name="chat" />
          <span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ moreinfoContact }}</span>
        </div>
      </div>
      <div class="slogan" v-html="Utils.presetHtmlText(moreinfoSlogan)" :class="{ ffen: getLocalLangCode() != 'zh' }" />
      <div class="noresponse">
        <span class="title">{{ moreinfoNoResponse?.title }}</span>
        <span class="content">{{ moreinfoNoResponse?.content }}</span>
      </div>
    </div>

    <Footer />

    <div class="bottom-btns" :class="{ show: !!showBottomBtns }">
      <div class="btnitem primary" @click="Utils.loginDialogToggle(true,'person')"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('plan_btn_applynow')}}</span></div>
      <div class="btnitem" @click="downloadFile"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('plan_btn_manual')}}</span></div>
    </div>
  </session>
</template>

<script setup>
  import { ref, onMounted, onUnmounted, watch } from 'vue';
  import EventBus from '@/assets/eventbus';
  import * as Utils from '@/assets/utils';
  import Banner from '@/components/banner/index.vue';
  import TopNavs from '@/components/topnavs/index.vue';
  import Icon from '@/components/icon/index.vue';
  import Footer from '@/components/footer/index.vue';
  import { useRouter, useRoute } from 'vue-router';
  const route = useRoute();

  import IMG_COVER_PERSON from './images/person.png';
  import IMG_COVER_UNIT from './images/unit.png';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';
  import router from '@/router';
  import { saveAs } from 'file-saver';
  import doc_cn_presur from '@/assets/docs/doc_cn_presur.pdf'; 
  import doc_jp_presur from '@/assets/docs/doc_jp_presur.pdf'; 
  import doc_kr_presur from '@/assets/docs/doc_kr_presur.pdf'; 
  import doc_en_presur from '@/assets/docs/doc_en_presur.pdf'; 


  const mode = ref('person');

  const pageFirstBlockRef = ref(null)

  //术前意外保障计划
  const block1Title = ref('');
  const block1Desc = ref('');
  const block1Btn1 = ref('');
  const block1Btn2 = ref('');
  const block1Cover = ref(null);
  const block1Init = () => {
    if(mode.value == 'person') {
      block1Title.value = LOCAL('plan_person');
      block1Desc.value = LOCAL('plan_person_desc');
      block1Btn1.value = LOCAL('plan_btn_applynow');
      block1Btn2.value = LOCAL('plan_btn_manual');
      block1Cover.value = IMG_COVER_PERSON
    }
    if(mode.value == 'unit') {
      block1Title.value = LOCAL('plan_unit');
      block1Desc.value = LOCAL('plan_unit_desc');
      block1Btn1.value = LOCAL('plan_btn_applynow');
      block1Btn2.value = LOCAL('plan_btn_manual');
      block1Cover.value = IMG_COVER_UNIT
    }
  }
  onMounted(() => {
    block1Init()
  });

  //保障范围
  const block2Title = ref('');
  const block2Category = ref([]);
  const block2List = ref([]);
  const block2Init = () => {
    block2Title.value = LOCAL('plan_coverage');
    block2Category.value = [
      { order: '01', name: LOCAL('plan_coverage_1'), icon: 'face' },
      { order: '02', name: LOCAL('plan_coverage_2'), icon: 'nose' },
      { order: '03', name: LOCAL('plan_coverage_3'), icon: 'eyes' },
      { order: '04', name: LOCAL('plan_coverage_4'), icon: 'boobs' },
      { order: '05', name: LOCAL('plan_coverage_5'), icon: 'fat' },
    ]
    if(mode.value == 'person') {
      block2List.value = [
        { title: LOCAL('plan_person_coverage_list_1_title'), desc: LOCAL('plan_person_coverage_list_1_desc'), icon: 'yiwaishenwang' },
        { title: LOCAL('plan_person_coverage_list_2_title'), desc: LOCAL('plan_person_coverage_list_2_desc'), icon: 'gongnengxingsunshang' },
        { title: LOCAL('plan_person_coverage_list_3_title'), desc: LOCAL('plan_person_coverage_list_3_desc'), icon: 'shoushushigu' },
        { title: LOCAL('plan_person_coverage_list_4_title'), desc: LOCAL('plan_person_coverage_list_4_desc'), icon: 'lianghuamanyidu' },
      ]
    }

    if(mode.value == 'unit') {
      block2List.value = [
        { title: LOCAL('plan_unit_coverage_list_1_title'), desc: LOCAL('plan_unit_coverage_list_1_desc'), icon: 'yiwaishenwang' },
        { title: LOCAL('plan_unit_coverage_list_2_title'), desc: LOCAL('plan_unit_coverage_list_2_desc'), icon: 'gongnengxingsunshang' },
        { title: LOCAL('plan_unit_coverage_list_3_title'), desc: LOCAL('plan_unit_coverage_list_3_desc'), icon: 'shoushushigu' },
        { title: LOCAL('plan_unit_coverage_list_4_title'), desc: LOCAL('plan_unit_coverage_list_4_desc'), icon: 'lianghuamanyidu' },
      ]
    }
  }
  onMounted(() => {
    block2Init()
  });

  //计划特色
  const block3Title = ref('');
  const block3List = ref([]);
  const block3Init = () => {
    block3Title.value = LOCAL('plan_features');
    if(mode.value == 'person') {
      block3List.value = [
        { title: LOCAL('plan_person_features_1_title'), desc: LOCAL('plan_person_features_1_desc'), icon: 'fast' },
        { title: LOCAL('plan_person_features_2_title'), desc: LOCAL('plan_person_features_2_desc'), icon: 'vip' },
        { title: LOCAL('plan_person_features_3_title'), desc: LOCAL('plan_person_features_3_desc'), icon: 'keshihuabaodan' },
        { title: LOCAL('plan_person_features_4_title'), desc: LOCAL('plan_person_features_4_desc'), icon: 'haiwaiyiliao' },
      ]
    }
    if(mode.value == 'unit') {
      block3List.value = [
        { title: LOCAL('plan_unit_features_1_title'), desc: LOCAL('plan_unit_features_1_desc'), icon: 'fast' },
        { title: LOCAL('plan_unit_features_2_title'), desc: LOCAL('plan_unit_features_2_desc'), icon: 'tishengzonghebeishu' },
        { title: LOCAL('plan_unit_features_3_title'), desc: LOCAL('plan_unit_features_3_desc'), icon: 'zhuanyiyewufengxian' },
        { title: LOCAL('plan_unit_features_4_title'), desc: LOCAL('plan_unit_features_4_desc'), icon: 'vip' },
      ]
    }
  }
  onMounted(() => {
    block3Init()
  });

  //更多资讯
  const moreinfoTitle = ref('');
  const moreinfoDesc = ref('');
  const moreinfoContact = ref('');
  const moreinfoSlogan = ref('');
  const moreinfoNoResponse = ref({ title: '', content: '' });
  const moreinfoInit = () => {
    moreinfoTitle.value = LOCAL('plan_moreinfo');
    moreinfoDesc.value = LOCAL('plan_moreinfo_desc');
    moreinfoContact.value = LOCAL('contactUs');
    moreinfoSlogan.value = LOCAL('plan_moreinfo_slogan');
    moreinfoNoResponse.value = {
      title: LOCAL('plan_moreinfo_nores'),
      content: LOCAL('plan_moreinfo_nores_desc'),
    }
  }
  onMounted(() => {
    moreinfoInit()
  });

  const block2Ref = ref(null);
  const showBottomBtns = ref(false);
  const scrollHandle = () => {
    const el = document.querySelector('.js-page-plan');
    el.addEventListener('scroll', e => {
      const curpoi = e.target.scrollTop + 66;
      if(curpoi > block2Ref.value.offsetTop){
        showBottomBtns.value = true;
      }else{
        showBottomBtns.value = false;
      }
    });
  }

const goBack = () => {
  router.go(-1)
}

const downloadFile = () => {
  let langver = getLocalLangCode()
  let makeid = () => {
      let text = '';
      let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    
      for (let i = 0; i < 16; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));
    
      return text;
  }
  if (langver == 'zh'){
    fetch(doc_cn_presur)
        .then((response) => response.blob())
        .then((blob) => saveAs(blob, makeid()))
        .catch(() => console.error('Error: Unable to download the file'));
  } else if (langver == 'jp'){
    fetch(doc_jp_presur)
        .then((response) => response.blob())
        .then((blob) => saveAs(blob, makeid()))
        .catch(() => console.error('Error: Unable to download the file'));
  } else if (langver == 'kr'){
    fetch(doc_kr_presur)
        .then((response) => response.blob())
        .then((blob) => saveAs(blob, makeid()))
        .catch(() => console.error('Error: Unable to download the file'));
  } else if (langver == 'en'){
    fetch(doc_en_presur)
        .then((response) => response.blob())
        .then((blob) => saveAs(blob, makeid()))
        .catch(() => console.error('Error: Unable to download the file'));
  }
      
}

  onMounted(() => {
    scrollHandle()
  });

  // 左侧回到顶部交互
  onMounted(() => {
    Utils.scrollToTop.register('js-page-plan');
    EventBus.on('global_page_scroll_action_js-page-plan', () => {
      pageFirstBlockRef.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });
    });
  });
</script>

<style scoped lang="less">
  @import "index.less";
</style>
